import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collapseLabel",
  "use": "icon-collapseLabel-usage",
  "viewBox": "0 0 14 11.999",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11.999\" id=\"icon-collapseLabel\">\r\n  <path id=\"icon-collapseLabel_联合_90\" data-name=\"联合 90\" class=\"cls-1\" d=\"M9593-7000h-14v-6h14v6Zm-13-1h12v-4h-12Zm9-3h2l-1,1Zm-8,1v-1h7v1Zm12-4h-14v-5h14v5Zm-13-1h12v-3h-12Z\" transform=\"translate(-9579 7011.999)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol